import React from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import { Button, Col, Form } from "react-bootstrap";
import { subscriptionConstants } from "../constants/subscriptionConstants";
import PriceTagsAutocomplete from "./PriceTagsAutocomplete";
import { getTaxRatePercent } from "../utilities/taxRate";

const AdvancedEditingBlock = ({ isEditing, isSaving }) => {
  const subscription = useMappedState((state) => state.subscriptions.subscription);
  const dispatch = useDispatch();

  const handleSubscriptionUpdate = (updatedData) => {
    dispatch({
      type: subscriptionConstants.UPDATE_ADVANCED_TAGS,
      payload: updatedData,
    });
  };

  const handleTaxRateChange = (input: string) => {
    const percent = Number(input);
    const validPercent = Number.isNaN(percent) ? 0 : percent;
    const adjustedPercent = Math.min(Math.max(validPercent, 0), 100);
    const decimalRate = String(adjustedPercent / 100) || "0";

    handleSubscriptionUpdate({ taxRate: decimalRate });
  };

  const sendNow = () => {
    dispatch({
      type: subscriptionConstants.POST_SEND_NOW,
      payload: {
        id: subscription.id,
        data: {
          customer_id: subscription.customer.id,
        },
      },
    });
  };

  return (
    <>
      <Col>
        <h6 className="mb-1">
          <small className="font-weight-bold">Price tag</small>
        </h6>
        {isEditing && !isSaving ? (
          <PriceTagsAutocomplete
            handleSubscriptionUpdate={handleSubscriptionUpdate}
            name={subscription?.priceTag?.name}
          />
        ) : (
          <p>{subscription?.priceTag?.name || "No tag"} </p>
        )}
      </Col>

      <Col>
        <h6 className="mb-1">
          <small className="font-weight-bold">Gift flow tag</small>
        </h6>
        {isEditing && !isSaving ? (
          <div>
            <Form.Control
              disabled={!isEditing}
              value={subscription?.giftFlowTag || ""}
              onChange={(e) => handleSubscriptionUpdate({ giftFlowTag: (e.target.value || null) })}
            />
            {subscription?.giftFlowTag && (
              <Button
                className="mt-4"
                onClick={() => handleSubscriptionUpdate({ giftFlowTag: null })}
              >
                Remove gift flow
              </Button>
            )}
          </div>
        ) : (
          <p>{subscription?.giftFlowTag || "No tag"}</p>
        )}
      </Col>

      <Col>
        <h6 className="mb-1">
          <small className="font-weight-bold">Tax rate (%)</small>
        </h6>
        {isEditing && !isSaving ? (
          <Form.Control
            type="number"
            min={0}
            max={100}
            step={0.1}
            value={getTaxRatePercent(subscription?.taxRate)}
            onChange={(e) => handleTaxRateChange(e.target.value)}
          />
        ) : (
          <p>
            {getTaxRatePercent(subscription?.taxRate) ? `${getTaxRatePercent(subscription?.taxRate)}%` : "No tax rate"}
          </p>
        )}
      </Col>

      {!subscription.sendNow.disable && (
        <Col>
          <Button onClick={sendNow}>Send now</Button>
        </Col>
      )}
    </>
  );
};

export default AdvancedEditingBlock;
